"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HighlightIcon;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Icon = require("./Icon");

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HighlightIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement("path", { d: "M19,4 C19.5128358,4 19.9355072,4.38604019 19.9932723,4.88337888 L20,5 L20,9.61483519 C20,9.69690861 19.9966323,9.77881993 19.9899356,9.8603674 C19.9966912,9.90581613 20,9.95252166 20,10 C20,10.1805703 19.9521405,10.3499624 19.8684145,10.4961832 C19.8658881,10.5018105 19.864041,10.5077569 19.8621752,10.513698 L19.7854301,10.7290072 L18,15.191 L18,19 C18,19.5128358 17.6139598,19.9355072 17.1166211,19.9932723 L17,20 L5,20 C4.44771525,20 4,19.5522847 4,19 C4,18.4871642 4.38604019,18.0644928 4.88337888,18.0067277 L5,18 L12,18 L12,15.194 L10.2145699,10.7290072 C10.1839016,10.6523364 10.1564596,10.5745518 10.1322835,10.495859 C10.0478595,10.3499624 10,10.1805703 10,10 C10,9.95252166 10.0033088,9.90581613 10.0097083,9.86010142 C10.0095959,9.85466244 10.0091437,9.84895569 10.0087078,9.84324723 L10,9.61483519 L10,5 C10,4.44771525 10.4477152,4 11,4 C11.5128358,4 11.9355072,4.38604019 11.9932723,4.88337888 L12,5 L12,9 L18,9 L18,5 C18,4.44771525 18.4477153,4 19,4 Z M16,16 L14,16 L14,18 L16,18 L16,16 Z M17.522,11 L12.477,11 L13.677,14 L16.322,14 L17.522,11 Z" })
  );
}